<template>
  <div>
    <FindList :always-show="true" />
  </div>
</template>

<script>
import FindList from './FindList.vue'

export default {
  name: 'HomePage',
  components: {
    FindList
  },
}
</script>
